import { render, staticRenderFns } from "./DesignatedVehicleTeam.vue?vue&type=template&id=740cb802"
import script from "./DesignatedVehicleTeam.vue?vue&type=script&lang=js"
export * from "./DesignatedVehicleTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports